import React from 'react';
import '../Styles/Navbar.css';

const Navbar = () => {
    return (
        <div className = "navbar">
            <h1>World Disaster Tracker</h1>
        </div>
    )
}

export default Navbar
